import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import useIsLoading from '../../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostJSON } from '../../../../../../../../../../../utils/globals/data'

interface ModalReopenSellOrderProps extends ModalReopenSellOrderLogicProps {}

const ModalReopenSellOrder: React.FC<ModalReopenSellOrderProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalReopenSellOrderLogic({ setOpened, ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureReopenSellOrder', '¿Seguro que quieres reabrir este pedido?'),
            subtitle: t('modificableAndAddOnceReopened', 'Podrás modificar y añadir datos una vez reabierto'),
            buttonAccept: t('accept', 'Aceptar'),
        }} loading={loading} />
    )
}

interface ModalReopenSellOrderLogicProps extends ModalEditComponentProps {}

const useModalReopenSellOrderLogic = ({ onSubmit, allRowData }: ModalReopenSellOrderLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading()
        const result = await twinFetchPostJSON('/api/app/order/sell/sellOrder/reopenSellOrder', { id: allRowData?.id })
        if (result) {
            onSubmit(false as any, {})
            endLoading()
        }
    }, [allRowData, onSubmit, endLoading, startLoading])
    return { handleOnAccept, loading }
}


export default ModalReopenSellOrder